import React from "react";
import { Link } from 'gatsby'
import Col from "react-bootstrap/Col";

const Product = props => {
	return (
		<div style={{ margin: 10, width: '100%' }}>

			{(props.newTab) ?
				<a href={props.link} target="_blank" rel="noopener noreferrer">
					<div className="card-1" style={{ padding: '1rem', backgroundColor: 'white' }}>
						<div style={{ fontWeight: 400, marginBottom: 10 }}>
							{props.name}
						</div>
						<div>
							<small style={{ fontWeight: 300 }}>{props.decription}</small>
						</div>
					</div>
				</a>
				:
				<Link to={props.link}>
					<div className="card-1" style={{ padding: '1rem', backgroundColor: 'white' }}>
						<div style={{ fontWeight: 400, marginBottom: 10 }}>
							{props.name}
						</div>
						<div>
							<small style={{ fontWeight: 300 }}>{props.decription}</small>
						</div>
					</div>
				</Link>
			}
		</div>
	);
};

Product.propTypes = {};

export default Product;
